import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

export default function VideoPlayer({
  id,
  src,
  width = "250px",
  height = "150px",
  overlay = true,
  registerVideoRef,
  onVideoPlay,
  onVideoPause,
  onVideoEnded,
  className = "",
}) {
  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setPlaying(true);
    videoRef.current?.play();
  };

  return (
    <div
      className={`relative rounded-md overflow-hidden bg-black ${className}`}
      style={{ width, height }}
    >
      <video
        id={id}
        ref={(element) => {
          videoRef.current = element;
          registerVideoRef?.(element);
        }}
        src={src ? `${src}#t=0.001` : undefined}
        preload="metadata"
        controls
        playsInline
        className="w-full h-full"
        onPlay={() => {
          setPlaying(true);
          onVideoPlay?.();
        }}
        onPause={() => {
          setPlaying(false);
          onVideoPause?.();
        }}
        onEnded={() => {
          setPlaying(false);
          onVideoEnded?.();
        }}
      />
      {overlay && !playing && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-black/30 cursor-pointer"
          onClick={handlePlay}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="text-white text-3xl opacity-90"
          />
        </div>
      )}
    </div>
  );
}
